import useCreateDefaultWishlist from '../../_Hooks/useWishlist/useCreateDefaultWishlist'

const GlobalHooks = () => {
    useCreateDefaultWishlist()

    return null
}

export default GlobalHooks
